import React, { useState, useRef, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import "../../../assets/css/Drivers/DriverAuth/DriverOtpVerification.css";
import otpverification from "../../../assets/images/otpverification.png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverOtpVerification = () => {
  const { baseUrl } = useContext(AppContext);
  const [otp, setOtp] = useState(['', '', '', '']);
  const otpInputRefs = useRef([]);
  const [loading, setLoading] = useState(false);

  // timer state - starts at 10 minutes (600 seconds)
  const [timeLeft, setTimeLeft] = useState(600);

  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  // countdown effect - runs every second
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  // convert seconds into mm:ss format
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        otpInputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleSend = () => {
    if (timeLeft <= 0) {
      alert('OTP expired, please resend');
      return;
    }

    const otpValue = otp.join('');
    if (otpValue.length !== 4) {
      alert('Please enter complete OTP');
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("user_type", "driver");
    formData.append("otp", otpValue);

    axios
      .post(`${baseUrl}/general/forgotpassword/verifyOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          navigate('/driver-reset-password', { state: { email } });
        } else {
          alert(response.data.message || "Invalid OTP");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  const handleResend = () => {
    setOtp(['', '', '', '']);
    otpInputRefs.current[0]?.focus();
    setTimeLeft(600); // reset timer on resend

    const formData = new FormData();
    formData.append("email", email);
    formData.append("user_type", "driver");

    axios
      .post(`${baseUrl}/general/forgotpassword/resendOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        alert(response.data.success ? "OTP resent" : response.data.message);
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  const handleBack = () => {
    navigate('/driver-forgot-password');
  };

  return (
    <div className="DriverOtpVerification-wrapper">
      <Container className="DriverOtpVerification-container">
        <div
          className="DriverOtpVerification-back-button"
          onClick={handleBack}
          role="button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <div className="DriverOtpVerification-image-card">
              <div className="DriverOtpVerification-image-box">
                <img
                  src={otpverification}
                  alt="OTP Verification Illustration"
                  className="DriverOtpVerification-illustration"
                />
              </div>
            </div>

            <h2 className="DriverOtpVerification-heading">OTP Verification</h2>
            <p className="DriverOtpVerification-subtext">
              Verify with the OTP sent to your email.
            </p>

            <div className="DriverOtpVerification-otp-inputs">
              {otp.map((digit, index) => (
                <Form.Control
                  key={index}
                  ref={(el) => (otpInputRefs.current[index] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="DriverOtpVerification-otp-input"
                />
              ))}
            </div>

            {/* timer text */}
            <p className="DriverOtpVerification-timer-text">
              {timeLeft > 0 ? (
                <>OTP expires in <strong>{formatTime(timeLeft)}</strong></>
              ) : (
                <span style={{ color: "red" }}>OTP expired</span>
              )}
            </p>

            <Button
              className="DriverOtpVerification-send-button w-100"
              onClick={handleSend}
              disabled={loading || timeLeft <= 0}
            >
              {loading ? "Verifying..." : "Send"}
            </Button>

            <p className="DriverOtpVerification-resend-text">
              Not Received Yet?{' '}
              <span
                className="DriverOtpVerification-resend-link"
                onClick={handleResend}
                role="button"
              >
                Resend it
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DriverOtpVerification;